import React, { useState } from "react";
import { useSelector } from "react-redux";

import secret from "../secret.json";

import TopNavBar from "../components/TopNavBar";
import WorksheetTable from "../features/worksheets/components/WorksheetTable.jsx";
import StudentManagementPage from "../features/student/components/StudentManagementPage";
import AcademyManagementPage from "../features/academy/components/AcademyManagementPage.jsx";
import AssignedWorksheetTable from "../features/worksheets/components/AssignedWorksheetTable/AssignedWorksheetTable.jsx";
import UnfinishedWorksheetTable from "../features/worksheets/components/UnfinishedWorksheetTable.jsx";
import AssignmentReviewTable from "../features/worksheets/components/AssignmentReviewTable.jsx";
import AssignedRetryWorksheetTable from "../features/worksheets/components/AssignedRetryWorksheetTable.jsx";
import AdminPage from "../features/admin/components/AdminPage.jsx";
import NotificationManagementPage from "../features/notification/components/NotificationManagementPage.jsx";
import PaperAssignmentPage from "../features/paper-assignment/components/PaperAssignmentPage.jsx";

const HomePage = () => {
  const { user } = useSelector((state) => state.auth);
  const tabList = [
    {
      name: "worksheet",
      text: "문제지 관리",
      subTabList: [
        {
          name: "list",
          text: "문제지 목록",
        },
        {
          name: "given",
          text: "출제 문제지 목록",
        },
        {
          name: "retry",
          text: "복습 문제지 목록",
        },
      ],
    },
    { name: "assignment", text: "과제 미완수자 관리", subTabList: [] },
    { name: "paper-assignment", text: "알림장 및 과제 관리", subTabList: [] },
    { name: "students", text: "학생별 학습 내역", subTabList: [] },
    { name: "notification", text: "알림톡 관리 (베타)", subTabList: [] },
    {
      name: "academy",
      text: "학원 관리",
      subTabList: [
        { name: "students", text: "재원생 관리" },
        { name: "settings", text: "로고 및 카카오채널 관리" },
      ],
    },
  ];
  if (secret.ADMIN_NAME_LIST.includes(user.nickname)) {
    tabList.push({
      name: "admin",
      text: "관리자",
      subTabList: [],
    });
  }
  const [topTab, setTopTab] = useState("worksheet");
  const [worksheetTab, setWorksheetTab] = useState("list");

  let content;
  if (topTab === "worksheet") {
    if (worksheetTab === "list") {
      // 문제지 목록 화면
      content = <WorksheetTable />;
    } else if (worksheetTab === "given") {
      // 출제 문제지 목록 탭
      content = <AssignedWorksheetTable />;
    } else if (worksheetTab === "retry") {
      // 복습 문제지 목록 탭
      content = <AssignedRetryWorksheetTable />;
    }
  } else if (topTab === "assignment") {
    // 과제 제출
    content = <UnfinishedWorksheetTable />;
  } else if (topTab === "paper-assignment") {
    // 지필 과제 관리
    content = <PaperAssignmentPage />;
  } else if (topTab === "students") {
    // 과제 제출
    content = <AssignmentReviewTable />;
  } else if (topTab === "notification") {
    // 알림톡 관리
    content = <NotificationManagementPage />;
  } else if (topTab === "academy") {
    if (worksheetTab === "students") {
      content = <StudentManagementPage />;
    } else {
      content = <AcademyManagementPage />;
    }
  } else if (topTab === "admin") {
    content = <AdminPage />;
  } else {
    content = (
      <div style={{ padding: "20px" }}>
        <h1>준비 중</h1>

        <div>아직 내용이 없습니다.</div>
      </div>
    );
  }

  return (
    <div
      style={{
        fontFamily: '"Noto Sans KR", sans-serif',
        backgroundColor: "#F6F8FA",
        minHeight: "100vh",
      }}
    >
      <TopNavBar
        topTab={topTab}
        setTopTab={setTopTab}
        worksheetTab={worksheetTab}
        setWorksheetTab={setWorksheetTab}
        tabList={tabList}
      />
      {content}
    </div>
  );
};

export default HomePage;
